import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'cigna-omni-messaging-system-generated-message',
  templateUrl: './system-generated-message.component.html',
  styleUrls: ['./system-generated-message.component.scss'],
})
export class OmniMessagingSystemGeneratedMessageComponent {}
